import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-family-member-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-family-member-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { ViewApplicationBaseComponent } from "../../../../view-application/shared/view-application-base/view-application-base.component";
import { ViewFamilyMemberCmConstants } from "./view-family-member-cm.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
let ViewFamilyMemberCmComponent = class ViewFamilyMemberCmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    changeDetectorRefs;
    routerParamsService;
    familyMemberForm;
    familyMemberGroups = [];
    familyMemberShowGroupsDropdown = false;
    familyMemberDisableAdd = true;
    familyMemberDisableFilterBy = true;
    familyMemberDisableEditing = true;
    familyMemberListLabel = ViewFamilyMemberCmConstants.FAMILY_LABEL;
    familyMemberListControl = ViewFamilyMemberCmConstants.FAMILY_CONTROL;
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
    }
    ngOnInit() {
        this.getMetadata();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
        this.familyMemberGroups = stepMeta.familyGroup;
        this.subscribeToSelectedApplication();
    }
    initForm() {
        this.familyMemberForm = this.aflaModuleStrategyService.form.get("familyMemberForm");
        this.familyMemberForm.reset();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    populateForm(application) {
        if (application && application.appId > 0) {
            this.familyMemberForm.markAllAsTouched();
        }
        const familyMemberListControl = this.familyMemberForm.get(this.familyMemberListControl);
        RecipientUtils.setRecipients(application.family, true, familyMemberListControl);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewFamilyMemberCmComponent = __decorate([
    Component({
        selector: "app-view-family-member-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewFamilyMemberCmComponent);
export { ViewFamilyMemberCmComponent };
